import { ENVIRONMENT } from "../config";

const perPage = (defaultValue = 25) =>
	ENVIRONMENT === "DEVELOPER" ? 10 : defaultValue;
export default perPage;
